import { useContext } from 'react';
import { StationsContext, AreasContext, StationsErrorContext, GetStationsAndAreasContext } from '../context';
export var useStations = function () { return useContext(StationsContext); };
export var useAreas = function () { return useContext(AreasContext); };
export var useStationsError = function () { return useContext(StationsErrorContext); };
export var useGetStationsAndAreas = function () { return useContext(GetStationsAndAreasContext); };
//# sourceMappingURL=stations-hooks.js.map